import * as React from 'react';
import {BiometricsResetStateProps, BiometricsResetDispatchProps} from '../../../types/mx/containers';

class BiometricsResetView extends React.Component<BiometricsResetStateProps & BiometricsResetDispatchProps, {}> {

    renderDetail() {
        return <React.Fragment>
            <p>
                Estas a punto de eliminar el registro de Biométrico de esta solicitud.
            </p>
            <p>
                Esta opción no se puede deshacer.
            </p>
        </React.Fragment>;
    }

    renderButton(onPressResetConfirm, onPressClose) {
        return <React.Fragment><a className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
                       onClick={onPressClose}>Cancelar</a>
            <a className="h-auto btn btn-link border-0 btn-form text-warning py-0 pr-0"
               onClick={onPressResetConfirm}>Resetear</a></React.Fragment>;
    }

    render() {
        const {onPressResetConfirm, onPressClose} = this.props;
        return (
            <div className="col-12 p-0">
                <div className="text-justify">
                    {this.renderDetail()}
                </div>
                <div className="pt-3 px-0 text-right border-top">
                    {this.renderButton(onPressResetConfirm, onPressClose)}
                </div>
            </div>
        );
    }
}

export default BiometricsResetView;